import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../../i18n/i18n';
import Select from 'react-select';
import { Fab } from '@material-ui/core';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import { Delete } from '../../../utils/Delete';
import ReactSelect from './../../../utils/ReactSelect';
import { Button, IconButton } from '@material-ui/core';
import { Export } from '../../../utils/Export';
import AddField from './AddField';
import MeteoDialog from './../../meteoblue/MeteoDialog';
import c from 'config';
var FileSaver = require('file-saver');

const styles = theme => ({
    primaryMain: {
        backgroundColor: theme.palette.primary.main,
    },
});
const CheckboxTable = checkboxHOC(ReactTable);;

export default class ViewField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            layerType: [], cropGroupType: [], localGovType: [], productionType: [], cropSubgroupType: [], cropType: [],
            showFilters: false, loading: false,
            page: 0, pageSize: 25, sorted: null, filtered: null,
            selection: [], selectAll: false, selectedRow: [],
            totalPages: 0, totalFields: 0,
            add: false, edit: false, delete: false,
            data: [], user_season: null,
            selectedCropGroup: [], docTitle: null, user_layer: null,
            meteo: false, mounting: true,
        };
        this.toggleSelection = this.toggleSelection.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('row');

        axios.get('api/season/drop_down')
            .then(res => {
                let seasons = res.data.data.map(item => item.id);
                axios.get('api/layer/layers_by_season', { params: { seasons } })
                    .then(res => {
                        this.setState({ layerType: res.data.data }, () => {
                            axios.get('api/season/activity_season')
                                .then(res => {
                                    this.setState({ user_season: res.data.data[0].id_default_sezona }, () => {
                                        axios.get('api/layer/layer_by_season', { params: { season: this.state.user_season } })
                                            .then(res => {
                                                this.setState({ user_layer: res.data.data[0].id }, () => {
                                                    this.setState({ mounting: false }, () => {
                                                        this.checkboxTable.wrappedInstance.fireFetchData();
                                                    })
                                                });
                                            })
                                            .catch(err => { console.log(err) })
                                    })
                                })
                                .catch(err => { console.log(err) })
                        });
                    })
                    .catch(err => { console.log(err); })
            })
            .catch(err => { console.log(err); })

        this.getByURL('crop_group/drop_down', 'cropGroupType');
        this.getByURL('crop_subgroup/drop_down', 'cropSubgroupType');
        this.getByURL('crop/drop_down', 'cropType');
        this.getByURL('katastarska_opstina/drop_down', 'localGovType');
        this.getByURL('vrsta_proizvodnje/drop_down', 'productionType');
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.data !== this.state.data) {
            let current = this.state.data.find(item => item.id === (this.state.selection.length === 1 ? this.state.selection[0] : null));
            if (current) {

                this.setState({
                    selectedRow: current
                });
            }
        }
    }

    getUser() {
        let user = localStorage.getItem('user');
        let userObject = JSON.parse(user);
        !user && window.location.replace(window.location.origin);
        return userObject;
    }

    getData(url, state, instance) {
        this.setState({ loading: true, data: [] });
        axios.get(`api/${url}`, {
            params: { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: state.filtered }
        })
            .then(res => {
                this.setState({
                    data: res.data.data,
                    totalPages: res.data.total_pages,
                    totalFields: res.data.total,
                    loading: false
                });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getData): ', error);
            })
    }

    getByURL(url, obj) {
        axios.get(`api/${url}`)
            .then(res => this.setState({ [obj]: res.data.data }))
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 2 (getByURL): ', error, ', URL: ', url);
            })
    }

    toggleAll = () => {
        const selectAll = this.state.selectAll ? false : true, selection = [];
        if (selectAll) {
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            currentRecords.forEach(item => { selection.push(item._original.id); });
        }
        this.setState({ selectAll, selection });
    };

    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection], selectedRow = null;
        const keyIndex = selection.indexOf(key);
        if (keyIndex >= 0) selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)];
        else selection.push(key);
        if (selection.length == 1) selectedRow = this.state.data.filter((el) => el.id == selection)[0];
        this.setState({ selection, selectedRow });
    };

    handleClick = () => {
        if (this.state.edit == true && this.state.add == false) this.setState({ edit: false, selectedRow: [] });
        else if (this.state.selection.length > 0 && this.state.add == false && this.state.edit == false) this.setState({ selectedRow: [] });
        this.setState({ add: !this.state.add }, () => {
            // if (this.state.add === false) this.getData('field/read', this.state);
            if (this.state.add === false) this.checkboxTable.wrappedInstance.fireFetchData();
            if (this.state.add == true && this.state.edit == false) this.setState({ selection: [], selectAll: false, });
        });
    };

    handleClickArchived = () => {
        this.setState({ selection: [], selectAll: false, })
    };
    handleMeteoClick = () => { this.setState({ meteo: !this.state.meteo }) };

    deleteItem = () => {
        axios.post(`api/field/delete`, { selection: this.state.selection })
            .then(res => {
                this.checkboxTable.wrappedInstance.fireFetchData();
                this.setState({ selection: [], delete: false });
            })
            .catch(err => {
                this.setState({ delete: false });
                wentWrong(i18n.t('Something went wrong, please try again!'))
            })
    };

    isSelected = key => { return this.state.selection.includes(key); };
    onSearchClick = () => this.setState({ showFilters: !this.state.showFilters });
    onEditClick = () => { this.setState({ add: !this.state.add, edit: true }); };
    onTableClick = () => this.props.history.push('/field');
    onDeleteClick = () => { this.setState({ delete: !this.state.delete }); };
    onExportClick = () => { this.setState({ export: !this.state.export }); };
    onMapClick = () => this.props.history.push('/maps');

    exportFunction = () => {
        const table = this.checkboxTable.getWrappedInstance();
        this.exportDocument(this.state.docTitle, table.state, 'api/field/read', { potpisan: this.state.potpisan, odbijen: this.state.odbijen });
        this.setState({ export: !this.state.export, docTitle: null });
    };

    exportDocument(title, state, url, filters) {
        let params = { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: state.filtered, filename: title };
        if (filters) params = { page: state.page, pageSize: state.pageSize, sorted: state.sorted, filtered: state.filtered, filename: title, filters };

        return axios({ url: url, method: 'GET', responseType: 'blob', params: params })
            .then(response => FileSaver.saveAs(new Blob([response.data]), `${title || 'file'}.xlsx`))
            .catch(err => console.log(err))
    };

    handleButtonClick = (cell) => {
        let row = { id: cell._original.id, naziv: cell.naziv };
        localStorage.setItem('row', JSON.stringify(row));
        this.onMapClick();
    };

    handleForecast = (cell) => {
        let row = { id: cell._original.id, naziv: cell.naziv };
        this.setState({ row, meteo: true });
    };

    render() {
        let layerType = this.state.layerType.map((item) => { return { label: item.naziv, value: item.id } });
        let cropGroupType = this.state.cropGroupType.map((item) => { return { label: item.naziv, value: item.id } });
        let cropSubgroupType = this.state.cropSubgroupType.map((item) => { return { label: item.naziv, value: item.id } });
        let cropType = this.state.cropType.map((item) => { return { label: item.naziv, value: item.id } });
        let localGovType = this.state.localGovType.map((item) => { return { label: item.naziv, value: item.id } });
        let productionType = this.state.productionType.map((item) => { return { label: item.naziv, value: item.id } });
        let layers = layerType.map(item => item.value);

        const columns = [
            { Header: i18n.t('Title'), accessor: 'naziv', width: 100 },
            { Header: i18n.t('Land area'), accessor: 'povrsina', width: 80 },

            { Header: i18n.t('Seedlings'), accessor: 'broj_cokota', width: 80 },
            { Header: i18n.t('Crop group'), accessor: 'kultura_grupa', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={cropGroupType} /> },
            { Header: i18n.t('Crop subgroup'), accessor: 'kultura_podgrupa', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={cropSubgroupType} /> },
            { Header: i18n.t('Crop'), accessor: 'kultura', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={cropType} /> },
            { Header: i18n.t('Sort/Hybrid'), accessor: 'sorta_naziv', width: 100 },
            {
                Header: i18n.t('Season'), accessor: 'layer',
                Filter: ({ filter, onChange }) => {
                    return <ReactSelect
                        filter
                        isMulti
                        name="label"
                        onChange={value => { onChange(value) }}

                        closeMenuOnSelect={false}
                        options={layerType}
                        className="multi-select-in-filter"
                        classNamePrefix="select"
                        placeholder={i18n.t('Select')}
                    />
                }
            },
            { Header: i18n.t('Local government'), accessor: 'kat_opstina', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={localGovType} /> },
            { id: 'has_activity', Header: i18n.t('Has activities'), accessor: d => d.has_activity, Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No'), width: 115 },
            { Header: i18n.t('Type of production'), accessor: 'vrsta_proizvodnje', Filter: ({ filter, onChange }) => <FilterSelect onChange={onChange} type={productionType} /> },
            // { id: 'semenska_proizvodnja', Header: i18n.t('Seed production'), accessor: d => d.semenska_proizvodnja, Cell: ({ value }) => value != 0 ? i18n.t('Yes') : i18n.t('No') },
            { id: 'geom_mobile', Header: i18n.t('Geometry'), accessor: d => d.geom_mobile, Cell: ({ value }) => value != null ? i18n.t('Yes') : i18n.t('No') },
            {
                width: 80,
                Header: i18n.t('Map'),
                accessor: 'map',
                Cell: cell => (
                    cell.row.geom_mobile !== null &&
                    <Button onClick={() => this.handleButtonClick(cell.row)} style={{ backgroundColor: 'transparent', color: 'black', height: '20px', width: '30px', textTransform: 'none' }}>
                        {i18n.t('Show')}
                    </Button>
                )
            },
            // {
            //     width: 100,
            //     Header: i18n.t('Forecast'),
            //     accessor: 'forecast',
            //     Cell: cell => (
            //         cell.row.geom_mobile !== null && 
            //         <Button onClick={() => this.handleForecast(cell.row)} style={{ backgroundColor: 'transparent', color: 'black', height: '20px', width: '30px', textTransform: 'none' }}>
            //             {i18n.t('Forecast')}
            //         </Button>
            //     )
            // }
        ];
        const user = this.getUser();
        if (user.id_region === 29) {
            columns.splice(2, 0, { Header: i18n.t('Parcel'), accessor: 'parcela_broj', width: 100 })
        }
        const url = 'field/read';


        const { toggleSelection, toggleAll, isSelected } = this;
        const { selectAll } = this.state;
        const checkboxProps = {
            selectAll, isSelected, toggleSelection, toggleAll, selectType: "checkbox",
            getTrProps: (state, rowInfo, instance) => {
                if (rowInfo) {
                    const selected = this.isSelected(rowInfo.original.id);
                    return { style: { backgroundColor: selected ? "#ACDAF1" : "inherit", fontSize: '13px', lineHeight: '20px', height: '32.8px' } };
                }
                return { style: { height: '32.8px' } };
            },
            getTheadFilterProps: () => { return { style: { backgroundColor: '#3E9571' } }; },
            getTheadTrProps: () => { return { style: { backgroundColor: '#04764e', color: '#FFFFFF' } }; },
        };

        const filterOptions = {
            defaultFiltered: [
                {
                    id: 'layer',
                    value: layerType.filter((element) => {
                        if (layers.includes(this.state.user_layer)) return element.value === this.state.user_layer;
                    })
                }
            ]
        };

        return (
            <div className="page">
                <div className="table-header">
                    <Fab onClick={() => this.onSearchClick()}
                        color="secondary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-search headerIcon" />
                    </Fab>
                    <Fab onClick={() => this.handleClick()}
                        color="secondary"
                        aria-label="add"
                        className="action-button">
                        <span className="icon-Plus headerIcon" />
                    </Fab>
                    {this.state.selection.length === 1 ?
                        <Fab onClick={() => this.onEditClick()}
                            color="secondary"
                            aria-label="edit"
                            className="action-button">
                            <span className="icon-Izmeni1 headerIcon" />
                        </Fab>
                        : null
                    }
                    {this.state.selection.length > 0 ?
                        <Fab onClick={() => this.onDeleteClick()}
                            color="secondary"
                            aria-label="add"
                            className="action-button">
                            <span className="icon-Kanta headerIcon" />
                        </Fab>
                        : null
                    }
                    <Button
                        onClick={() => this.onExportClick()}
                        variant="fab"
                        color="secondary"
                        aria-label="add"
                        className="action-button"
                    >
                        <span className="icon-download headerIcon" />
                    </Button>
                </div>
                <CheckboxTable ref={r => (this.checkboxTable = r)}
                    manual
                    data={this.state.data}
                    paging={true}
                    columns={columns}
                    keyField={'id'}
                    pageSizeOptions={[10, 25, 50, 100]}
                    defaultPageSize={25}
                    filterable={this.state.showFilters}
                    pages={this.state.totalPages}
                    showPaginationTop
                    showPaginationBottom={false}
                    onFetchData={(state, instance) => {
                        if (this.state.mounting === false) { this.getData(url, state, instance); }
                    }}
                    loading={this.state.mounting}
                    className="-striped -highlight"
                    previousText={i18n.t('Previous')}
                    nextText={i18n.t('Next')}
                    loadingText={i18n.t('Loading...')}
                    noDataText={i18n.t('No rows found')}
                    pageText={i18n.t('Page')}
                    ofText={i18n.t('of')}
                    rowsText={i18n.t('rows')}
                    {...checkboxProps}
                    {...filterOptions}
                    PreviousComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF',
                        }}>{props.children}</button>
                    )}
                    NextComponent={(props) => (
                        <button {...props} className='-btn' style={{
                            backgroundColor: '#4FA2CD',
                            color: '#FFFFFF'
                        }}>{props.children}</button>
                    )}
                />
                {this.state.export && <Export
                    export={this.state.export}
                    onTextChange={({ title }) => { this.setState({ docTitle: title }); }}
                    handleClose={this.onExportClick}
                    exportDoc={this.exportFunction} />
                }
                {this.state.add && <AddField add={this.state.add} edit={this.state.edit} layer={this.state.user_layer} handleClose={this.handleClick} handleCloseArchived={this.handleClickArchived} data={this.state.selectedRow} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}
                {this.state.meteo && <MeteoDialog open={this.state.meteo} handleClick={this.handleMeteoClick} row={this.state.row} />}
            </div>
        );
    }
}

function FilterSelect(props) {
    return <Select
        isMulti
        name="naziv"
        onChange={value => { props.onChange(value) }}
        closeMenuOnSelect={false}
        options={props.type}
        className="multi-select-in-filter"
        classNamePrefix="select"
        placeholder={i18n.t('Select')}
    />
}